import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../../context/AuthContext";
import { useHistory } from "react-router-dom";
import BrandingHeader from "../../components/BrandingHeader";
import ProgressBar from "../../components/ProgressBar";
import { db, storage, createdAt } from "../../firebase";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useDebouncedCallback } from "use-debounce";
import { ToastContainer, toast } from "react-toastify";
import { CountryDropdown } from "react-country-region-selector";
import { toTitleCase } from "../../utils";

export default function SetupMentor() {
  const { currentUser } = useAuth();
  const history = useHistory();
  const [isusernameValid, setisusernameValid] = useState(true);
  const [file, setFile] = useState("");
  const [country, setCountry] = useState("");
  const [loading, setLoading] = useState();
  const [spinner, setSpinner] = useState(false);
  const [progress, setProgress] = useState(0);
  const [usernameMessage, setUsernameMessage] = useState(null);
  const [url, setUrl] = useState(null);
  const animatedComponents = makeAnimated();
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const meetLinkRef = useRef();

  const types = ["image/png", "image/jpeg"];

  let temp = JSON.parse(sessionStorage.getItem("isRegistered"));

  useEffect(() => {
    if (currentUser.displayName !== null && currentUser.emailVerfied) {
      history.push("/mentor/dashboard");
    } else {
      history.push("/mentor/setup");
    }
  }, [history, currentUser, temp.registered]);

  const handleChange = async (e) => {
    let file = e.target.files[0];

    if (file.size > 2097152) {
      toast.error("File size too big, Max file size is 2MB");
    } else {
      if (file && types.includes(file.type)) {
        setFile(file);
        setLoading(true);
        let storageRef = storage.ref(`mentor/${file.name}`).put(file);
        storageRef.on(
          "state_changed",
          (snap) => {
            let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
            setProgress(percentage);
          },
          (error) => {
            console.log(error);
          },
          async () => {
            let url = await storage
              .ref("mentor")
              .child(file.name)
              .getDownloadURL();
            setUrl(url);
            setLoading(false);
          }
        );
      } else {
        setFile(null);
        toast.error("Please select an image file (png or jpeg)");
      }
    }
  };

  async function onSubmit(e) {
    e.preventDefault();
    setSpinner(true);

    let name = e.target.name.value;
    const meetLink = e.target.meetLink.value;
    const bio = e.target.bio.value;
    const company = e.target.company.value;
    const role = e.target.role.value;
    const username = e.target.username.value;
    const linkedin = e.target.linkedin.value;
    const github = e.target.github.value;

    name = toTitleCase(name);

    temp.registered = true;

    if (meetLink === "https://calendly.com/") {
      toast.warning("Please check your calendly link");
    } else if (!isusernameValid) {
      toast.error("Username is not valid");
    } else if (
      meetLink.match(/^(https?:\/\/)?(www\.)?calendly.com\/[a-zA-Z0-9(?)?]/)
    ) {
      try {
        await db.collection("registered").doc(currentUser.uid).set({
          user: false,
        });
        await db
          .collection("mentors")
          .doc(currentUser.uid)
          .set({
            name: name,
            country: country,
            meetLink: meetLink,
            linkedin: linkedin,
            github: github,
            bio: bio,
            company: company,
            role: role,
            invites: 3,
            public: true,
            email: currentUser.email,
            status: false,
            profilePic:
              url ||
              "https://images.unsplash.com/photo-1486520299386-6d106b22014b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80",
            createdAt: createdAt,
            uid: currentUser.uid,
            interest: selectedChoice,
            topics: selectedTopic,
            username: username,
          });
        currentUser.updateProfile({
          displayName: name,
          photoURL:
            url ||
            "https://images.unsplash.com/photo-1486520299386-6d106b22014b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80",
        });
        await db
          .collection("invitedMentors")
          .doc(currentUser.email)
          .delete()
          .then(() => {})
          .catch((error) => {
            toast.error("Error removing document: ", error);
          });
        sendEmail(currentUser.email, name);
        let isRegistered = {
          registered: true,
        };
        sessionStorage.setItem("isRegistered", JSON.stringify(isRegistered));
        history.push("/mentor/dashboard");
        setSpinner(false);
      } catch {
        toast.error("Please fill all the details");
        setSpinner(false);
      }
      setLoading(false);
      setSpinner(false);
    } else {
      toast.error("Calendly url is invalid");
      setSpinner(false);
    }
  }

  async function sendEmail(myEmail, myName) {
    await fetch(
      "http://devcolony-env.eba-gse8qppb.us-west-2.elasticbeanstalk.com/sendmail/",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          email: myEmail,
          name: myName,
        }),
      }
    );
  }

  const choices = [
    { value: "Android", label: "Android" },
    { value: "iOS", label: "iOS" },
    { value: "Flutter", label: "Flutter" },
    { value: "AR/VR", label: "AR/VR" },
    { value: "AWS", label: "AWS" },
    { value: "Java", label: "Java" },
    { value: "Spring Boot", label: "Spring Boot" },
    { value: "Machine learning", label: "Machine learning" },
    { value: "Scalable systems", label: "Scalable systems" },
    { value: "GCP", label: "GCP" },
    { value: "Azure", label: "Azure" },
    { value: "Firebase", label: "Firebase" },
    { value: "Angular.js", label: "Angular.js" },
    { value: "React.js", label: "React.js" },
    { value: "Vue.js", label: "Vue.js" },
    { value: "Next.js", label: "Next.js" },
    { value: "Nuxt.js", label: "Nuxt.js" },
    { value: "Cyber security", label: "Cyber Security" },
    { value: "SQL", label: "SQL" },
    { value: "MongoDB", label: "MongoDB" },
    { value: "GraphQL", label: "GraphQL" },
    { value: "Node.js", label: "Node.js" },
    { value: "GoLang", label: "GoLang" },
    { value: "Python", label: "Python" },
    { value: "Git", label: "Git" },
    { value: "Unity", label: "Unity" },
  ];

  const topics = [
    { value: "Career advice", label: "Career advice" },
    { value: "Portfolio review", label: "Portfolio review" },
    { value: "Developer career path", label: "Developer career path" },
    { value: "Interview tips", label: "Interview tips" },
    {
      value: "Getting most out of internships",
      label: "Getting most out of internships",
    },
    { value: "Public speaking", label: "Public speaking" },
    { value: "Open source", label: "Open source" },
    { value: "Tech communities", label: "Tech communities" },
    {
      value: "Building scalable products",
      label: "Building scalable products",
    },
  ];

  const checkUsername = useDebouncedCallback(async (value) => {
    var query = db.collection("mentors");
    query = query.where("username", ">=", value).where("username", "<=", value);
    let regex = /^[a-z0-9_-]{4,16}$/;

    if (regex.test(value)) {
      await query
        .get()
        .then((snapshot) => {
          let result = snapshot.docs.map((doc) => doc.data());
          setisusernameValid(true);
          setLoading(false);
          if (result.length > 0) {
            setUsernameMessage("Username not available");
            setisusernameValid(false);
          } else {
            setUsernameMessage("Username available");
            setisusernameValid(true);
          }
        })
        .catch((error) => {
          toast.error("Error getting document: ", error);
        });
    } else {
      if (value.length > 0) {
        setUsernameMessage("Invalid username");
        setisusernameValid(false);
        toast.error(
          "Usernames must have 4 characters and can only use letters, numbers, underscores, and periods."
        );
      } else {
        setUsernameMessage("");
        setisusernameValid(false);
      }
    }
  }, 1000);

  const handleInterest = (item) => {
    const selected = item.map((data) => {
      return `${data.value}`;
    });

    setSelectedChoice(selected);
  };

  const selectCountry = (val) => {
    setCountry(val);
  };

  const handleTopics = (item) => {
    const selected = item.map((data) => {
      return `${data.value}`;
    });
    setSelectedTopic(selected);
  };

  return (
    <>
      <BrandingHeader />
      <div className="container mx-auto px-4 sm:px-2">
        <div className="mx-auto sm:w-2/4">
          <h1 className="text-2xl p-4 sm:p-5 sm:text-3xl font-semibold py-12 sm:py-4 sm:mt-8 ">
            Hi,{" "}
            {currentUser.displayName
              ? currentUser.displayName
              : currentUser.email.split("@")[0]}
            !
            <p className="font-medium text-lg sm:text-xl mt-4">
              Let's get you started in this community.
            </p>
          </h1>
        </div>
        <div>
          <div className="mx-auto sm:w-1/2">
            <div className="md:grid md:grid-cols-1 ">
              <form onSubmit={onSubmit}>
                <div className="sm:rounded-md sm:overflow-hidden">
                  <div className="px-4 bg-white space-y-6 sm:p-6">
                    <div class="grid grid-cols-1 space-y-2">
                      <label class="block text-lg font-medium text-gray-900">
                        Add your profile photo
                      </label>
                      <p className="text-sm font-medium text-gray-700">
                        A nice smiley photo of you - where you can clearly see
                        the face.
                      </p>
                      <div class="flex items-center justify-center w-full">
                        <label class="flex flex-col rounded-lg border-4 border-dashed w-full h-60 p-10 mt-2 group text-center">
                          <div class=" w-full text-center flex flex-col items-center justify-center items-center  ">
                            {!file && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-8 sm:w-10 h-10 mt-8 text-blue-400 mb-2 group-hover:text-blue-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                />
                              </svg>
                            )}
                            <div className="w-full">
                              {file && (
                                <ProgressBar progress={progress} url={url} />
                              )}
                            </div>

                            <div class="flex flex-auto h-max  mx-auto ">
                              {file && (
                                <img
                                  class="has-mask h-16 sm:h-40 object-center rounded-lg"
                                  src={!url ? "" : url}
                                  alt=""
                                />
                              )}
                            </div>
                            {!file && (
                              <p class="pointer-none text-gray-500 ">
                                <span>Drag and drop</span> files here <br /> or{" "}
                                select a file from your computer
                              </p>
                            )}
                          </div>
                          <input
                            type="file"
                            max-file-size="1024"
                            id="file-upload"
                            name="file-upload"
                            onInvalid={() => toast.error("image is required")}
                            className="sr-only"
                            onChange={handleChange}
                            required
                          />
                        </label>
                      </div>
                      {!file && (
                        <p class="text-sm text-gray-600">
                          <span>
                            File type: png, jpeg only and must be less than 2 mb
                          </span>
                        </p>
                      )}
                      <span>
                        {file && (
                          <div className="ml-2 truncate hidden md:inline">
                            {file.name}
                          </div>
                        )}
                      </span>
                    </div>
                    <div className="flex justify-between items-end">
                      <div className="col-span-6 sm:col-span-3">
                        <label
                          htmlFor="first_name"
                          className="block text-md font-medium text-gray-900"
                        >
                          Username
                        </label>
                        <div className="relative">
                          <div class="absolute flex border border-transparent left-0 top-0 h-full w-10">
                            <div class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-gray-600 text-lg h-full w-full">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                                />
                              </svg>
                            </div>
                          </div>
                          <input
                            type="text"
                            name="username"
                            onInvalid={() =>
                              toast.error("username is required")
                            }
                            onChange={(e) =>
                              checkUsername(
                                e.target.value.toLowerCase(),
                                "name"
                              )
                            }
                            id="username"
                            placeholder="username"
                            className="
                          mt-1
                          block
                          w-full
                          px-5
                          pl-12
                          py-2.5
                          text-base
                          placeholder-gray-300
                          transition
                          duration-500
                          ease-in-out
                          transform
                          border border-transparent
                          rounded-lg
                          text-neutral-600
                          bg-gray-100
                          focus:outline-none
                          focus:border-transparent
                          focus:ring-2
                          focus:ring-white
                          focus:ring-offset-2
                          focus:ring-offset-gray-300
                        "
                            required
                          />
                        </div>
                      </div>

                      {usernameMessage && (
                        <div class="flex flex-row items-center border-b sm:border-b-0 w-full sm:w-auto pb-4 sm:pb-0">
                          <div class="text-green-500">
                            {isusernameValid && (
                              <svg
                                class="w-6 sm:w-5 h-6 sm:h-5"
                                fill="none"
                                stroke="green"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                ></path>
                              </svg>
                            )}
                            {!isusernameValid && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-6 sm:w-5 h-6 sm:h-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="red"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            )}
                          </div>
                          <div class="text-sm font-medium ml-3">
                            {usernameMessage}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="first_name"
                        className="block text-md font-medium text-gray-900"
                      >
                        Your Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        id="name"
                        onInvalid={() => toast.error("name is required")}
                        autoComplete="given-name"
                        placeholder="what should we call you?"
                        className="
                          mt-1
                          block
                          w-full
                          px-5
                          py-2.5
                          text-base
                          placeholder-gray-300
                          transition
                          duration-500
                          ease-in-out
                          transform
                          border border-transparent
                          rounded-lg
                          text-neutral-600
                          bg-gray-100
                          focus:outline-none
                          focus:border-transparent
                          focus:ring-2
                          focus:ring-white
                          focus:ring-offset-2
                          focus:ring-offset-gray-300
                        "
                        required
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="first_name"
                        className="block text-md font-medium text-gray-900"
                      >
                        About you
                      </label>
                      <textarea
                        type="text"
                        name="bio"
                        id="bio"
                        maxlength="200"
                        onInvalid={() => toast.error("about you is required")}
                        placeholder="tell us something about yourself"
                        className="
                          mt-1
                          block
                          w-full
                          px-5
                          py-2.5
                          text-base
                          placeholder-gray-300
                          transition
                          duration-500
                          ease-in-out
                          transform
                          border border-transparent
                          rounded-lg
                          text-neutral-600
                          bg-gray-100
                          focus:outline-none
                          focus:border-transparent
                          focus:ring-2
                          focus:ring-white
                          focus:ring-offset-2
                          focus:ring-offset-gray-300
                        "
                        required
                      />
                      <p class="text-sm text-gray-300 mt-2">
                        <span>Max character: 200</span>
                      </p>
                    </div>

                    <CountryDropdown
                      onChange={selectCountry}
                      value={country}
                      onInvalid={() => toast.error("country is required")}
                      className="
                      mt-1
                      block
                      w-full
                      px-5
                      py-2.5
                      text-base
                      placeholder-gray-300
                      transition
                      duration-500
                      ease-in-out
                      transform
                      border border-transparent
                      rounded-lg
                      text-neutral-600
                      bg-gray-100
                      focus:outline-none
                      focus:border-transparent
                      focus:ring-2
                      focus:ring-white
                      focus:ring-offset-2
                      focus:ring-offset-gray-300
                    "
                      required
                    />

                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="interest"
                        className="block text-md font-medium text-gray-900"
                      >
                        Expertise
                      </label>

                      <Select
                        isMulti
                        components={animatedComponents}
                        options={choices}
                        value={choices.value}
                        onChange={handleInterest}
                        onInvalid={() => toast.error("Expertise is required")}
                        required
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="interest"
                        className="block text-md font-medium text-gray-900"
                      >
                        Topic of Interest
                      </label>

                      <Select
                        isMulti
                        components={animatedComponents}
                        options={topics}
                        value={topics.value}
                        onChange={handleTopics}
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="first_name"
                        className="block text-md font-medium text-gray-900"
                      >
                        Company
                      </label>
                      <input
                        type="text"
                        name="company"
                        id="company"
                        onInvalid={() =>
                          toast.error("company name is required")
                        }
                        placeholder="current organization you're working with"
                        className="
                        mt-1
                        block
                        w-full
                        px-5
                        py-2.5
                        text-base
                        placeholder-gray-300
                        transition
                        duration-500
                        ease-in-out
                        transform
                        border border-transparent
                        rounded-lg
                        text-neutral-600
                        bg-gray-100
                        focus:outline-none
                        focus:border-transparent
                        focus:ring-2
                        focus:ring-white
                        focus:ring-offset-2
                        focus:ring-offset-gray-300
                      "
                        required
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="first_name"
                        className="block text-md font-medium text-gray-900"
                      >
                        Current Role at this organization
                      </label>
                      <input
                        type="text"
                        name="role"
                        id="role"
                        onInvalid={() =>
                          toast.error("company role is required")
                        }
                        placeholder="eg: Software Engineer, Data Analyst, Product Manager"
                        className="
                        mt-1
                        block
                        w-full
                        px-5
                        py-2.5
                        text-base
                        placeholder-gray-300
                        transition
                        duration-500
                        ease-in-out
                        transform
                        border border-transparent
                        rounded-lg
                        text-neutral-600
                        bg-gray-100
                        focus:outline-none
                        focus:border-transparent
                        focus:ring-2
                        focus:ring-white
                        focus:ring-offset-2
                        focus:ring-offset-gray-300
                      "
                        required
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="first_name"
                        className="block text-md font-medium text-gray-900"
                      >
                        Linkedin profile
                      </label>
                      <input
                        type="text"
                        name="linkedin"
                        onInvalid={() =>
                          toast.error("linkedin url is required")
                        }
                        id="linkedin"
                        placeholder="https://linkedin.com/in/your"
                        className="
                          mt-1
                          block
                          w-full
                          px-5
                          py-2.5
                          text-base
                          placeholder-gray-300
                          transition
                          duration-500
                          ease-in-out
                          transform
                          border border-transparent
                          rounded-lg
                          text-neutral-600
                          bg-gray-100
                          focus:outline-none
                          focus:border-transparent
                          focus:ring-2
                          focus:ring-white
                          focus:ring-offset-2
                          focus:ring-offset-gray-300
                        "
                        required
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="first_name"
                        className="block text-md font-medium text-gray-900"
                      >
                        Calendly Link
                      </label>
                      <input
                        type="text"
                        name="meetLink"
                        onInvalid={() =>
                          toast.error("calendly link is required")
                        }
                        id="meetLink"
                        placeholder="https://calendly.com/your"
                        ref={meetLinkRef}
                        className="
                        mt-1
                        block
                        w-full
                        px-5
                        py-2.5
                        text-base
                        placeholder-gray-300
                        transition
                        duration-500
                        ease-in-out
                        transform
                        border border-transparent
                        rounded-lg
                        text-neutral-600
                        bg-gray-100
                        focus:outline-none
                        focus:border-transparent
                        focus:ring-2
                        focus:ring-white
                        focus:ring-offset-2
                        focus:ring-offset-gray-300
                      "
                        required
                      />
                      <p class="text-sm text-gray-300 mt-2">
                        <span>
                          Note: Please provide atleast 30 minutes meeting link
                        </span>
                      </p>
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="first_name"
                        className="block text-md font-medium text-gray-900"
                      >
                        GitHub profile{" "}
                        <span className="text-sm text-gray-500">
                          (optional)
                        </span>
                      </label>
                      <input
                        type="url"
                        name="github"
                        id="github"
                        placeholder="https://github.com/username"
                        className="
                          mt-1
                          block
                          w-full
                          px-5
                          py-2.5
                          text-base
                          placeholder-gray-300
                          transition
                          duration-500
                          ease-in-out
                          transform
                          border border-transparent
                          rounded-lg
                          text-neutral-600
                          bg-gray-100
                          focus:outline-none
                          focus:border-transparent
                          focus:ring-2
                          focus:ring-white
                          focus:ring-offset-2
                          focus:ring-offset-gray-300
                        "
                      />
                    </div>

                    <div className="flex items-start justify-between mt-4">
                      <div className="flex items-start">
                        <input
                          id="remember_me"
                          name="remember_me"
                          type="checkbox"
                          className="h-4 w-4 text-blue-600  border-gray-300 rounded"
                          required
                          autofocus
                        />
                        <label className="ml-2 block text-sm text-gray-900 ">
                          I have read and accept the{" "}
                          <a
                            href="https://devcolony.notion.site/Terms-of-Use-cc89d10ca5414bf98ad238590f8d5097"
                            className="text-blue-700"
                          >
                            Terms & conditions
                          </a>
                        </label>
                      </div>

                      <div className="text-sm"></div>
                    </div>
                  </div>
                  <div className="px-4 py-12 text-right sm:px-6">
                    <button
                      type="submit"
                      className="inline-flex justify-center py-3 px-8 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gradient-to-r from-blue-500 to-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                      disabled={loading}
                    >
                      Continue
                      {spinner && (
                        <div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-300 h-5 w-5 ml-4"></div>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer hideProgressBar={true} />
    </>
  );
}
